import ENUM from '../ENUM'

export default {
    kind: 'OverallScoreSlide',
    filters: [
        {
            name: ENUM().comparisonSurveyIds,
        },
    ],
}
